import { BlockInstanceType } from '../../blocks/BlockInterface';
import { PropertyType } from '../Property';
import { LongText, String, RichText } from '../baseTypes';
import { BlockInstancePropertiesExtractor } from './blockInstancePropertiesExtractor';
import { BlockPropertyTemplateVariableNameGetter } from './blockPropertyTemplateVariableNameGetter';
import { BlockPropertyTypeIsWhitelistedAndTemplatedFilterPredicate } from './blockPropertyTypeIsWhitelistedAndTemplatedFilterPredicate';
import { BlockRegistry } from './blockRegistry';

const WHITELISTED_PROPERTY_TYPES = [LongText, String, RichText] as const;

const TEXT_PROPERTY_TYPES = [LongText, String, RichText] as const;

const TEXT_PROPERTY_TYPE_NAMES = TEXT_PROPERTY_TYPES.map(type => type.name);

export class BlockInstanceTemplatedPropertiesExtractor extends BlockInstancePropertiesExtractor {
  constructor(
    protected rootBlockInstance: BlockInstanceType,
    protected blockRegistry: BlockRegistry,
    protected mergableTypeNames: ReadonlyArray<string> = TEXT_PROPERTY_TYPE_NAMES
  ) {
    super(
      rootBlockInstance,
      blockRegistry,
      new BlockPropertyTemplateVariableNameGetter(),
      new BlockPropertyTypeIsWhitelistedAndTemplatedFilterPredicate(
        WHITELISTED_PROPERTY_TYPES,
        blockRegistry
      )
    );
  }

  mergeProperties(
    propertyName: string,
    propertyTypeA: PropertyType,
    propertyTypeB: PropertyType
  ): PropertyType {
    // TODO: the merging logic is kept simple because we are only supporting text types. Future state we would need a compatible merge mapping.
    if (
      !this.mergableTypeNames.includes(propertyTypeA.type) ||
      !this.mergableTypeNames.includes(propertyTypeB.type)
    ) {
      throw new Error(
        `Incompatible instances of template variable ${propertyName} found.`
      );
    }

    return {
      ...propertyTypeA,
      ...propertyTypeB,
      type: String.name,
      validators: [],
    };
  }
}
